export const isBrowser: boolean = typeof window !== 'undefined';
export const API_VERSION_HEADER_KEY = 'x-api-v2-version';
